import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

export const DateSeparator = ({ date }) => {
  const formattedDate = moment(date).format('MMM D, YYYY');

  return (
    <div className='date-separator'>
      {formattedDate}
    </div>
  );
};

DateSeparator.propTypes = {
  date: PropTypes.object
};
